import { useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import { Dropdown } from '@components/common/Dropdown';
import CommonWrapper from '@components/modal/CommonWrapper';
import useModal from '@lib/hooks/useModal';
import { swalReturnWarning } from '@util/commonFunctions';
import { NUMBER_ONLY_REGEX } from '@util/text';
import styled from 'styled-components';
import Swal from 'sweetalert2';

import { Label1 } from '@/pages/merchant/seat/lockerChange';

const AddTimeBar = styled.div`
  display: flex;
  align-items: center;
  input {
    width: 20%;
  }
  p {
    margin: 0 8px 0 4px;
    font-size: 15px;
  }
  select {
    width: 30%;
  }
`;
type TicketTimeEditV2Props = {
  data: Ticket;
  time: (value: number) => void;
  setActualDay: (value: number) => void;
  payType: (value: string) => void;
  setActualAmount: (value: number) => void;
  check: (value: boolean) => void;
  signData: (value: string) => void;
};

const TicketTimeEditV2 = ({
  data,
  time,
  setActualDay,
  payType,
  setActualAmount,
  check,
  signData,
}: TicketTimeEditV2Props) => {
  const { closeLatestModal } = useModal();
  const [day, setDay] = useState<string>('0');
  const [hour, setHour] = useState<string>('1');
  const [min, setMin] = useState<string>('0');
  const [sign, setSign] = useState<string>('+');
  const [amount, setAmount] = useState<string>('0');

  const close = () => closeLatestModal();
  const setData = () => {
    check(false);
    time(0);
    setActualDay(0);
    payType('cash');
    setActualAmount(0);
  };
  const getCalculatedSeconds = (hour: string, min: string) => {
    try {
      return Number(hour) * 3600 + Number(min) * 60;
    } catch (error) {
      swalReturnWarning('시간, 분을 숫자로 입력해 주세요.');
      return -1;
    }
  };
  const changeSec = () => {
    const calculatedTime = getCalculatedSeconds(hour, min);
    if (calculatedTime === -1) return;
    signData(sign);
    setActualAmount(Number(amount));
    setActualDay(Number(day));
    time(calculatedTime);
  };
  const replaceAsNumber = (numString: string) => {
    const replaced = numString.replace(NUMBER_ONLY_REGEX, '');
    if (!replaced) return '0';
    return parseInt(replaced).toString();
  };

  const replaceAsNumberMinute = (numString: string) => {
    const replaced = numString.replace(NUMBER_ONLY_REGEX, '');
    if (!replaced) return '0';
    const parsedValue = parseInt(replaced);
    if (parsedValue > 59) return '59';
    return parsedValue.toString();
  };

  useEffect(() => {
    setData();
  }, []);

  const addTimeAndDayModal = () => {
    const calculatedTime = getCalculatedSeconds(hour, min);
    if (
      ((data.type === 1 || data.type === 3) && calculatedTime === 0) ||
      ((data.type === 2 || data.type === 5) && !day) ||
      !amount
    )
      return Swal.fire({
        icon: 'error',
        title: '모든 값을 입력해주세요',
        timer: 3500,
      });
    changeSec();
    check(true);
    close();
  };
  return (
    <CommonWrapper
      title="시간/기간 수정"
      onConfirm={addTimeAndDayModal}
      confirmBtnText="변경"
      notCloseWhenConfirm>
      {data.type === 1 || data.type === 3 ? (
        <>
          <h5 style={{ fontSize: '14px' }}>추가 시간</h5>
          <Label1>
            <AddTimeBar>
              <Input
                className="form-control"
                type="text"
                name="time"
                value={hour}
                onChange={(e) => setHour(e.target.value)}
              />
              <p>시</p>
              <Input
                className="form-control"
                type="text"
                name="time"
                value={min}
                onChange={(e) => {
                  setMin(replaceAsNumberMinute(e.target.value));
                }}
              />
              <p>분</p>
              <Dropdown style={{ width: '100%' }}>
                <select value={sign} onChange={(e) => setSign(e.target.value)}>
                  <option value="+" defaultChecked>
                    추가
                  </option>
                  <option value="-">차감</option>
                </select>
              </Dropdown>
            </AddTimeBar>
          </Label1>
        </>
      ) : (
        <Label1>
          <h5>추가 일자</h5>
          <Input
            className="form-control"
            type="text"
            name="day"
            value={day}
            onChange={(e) => setDay(replaceAsNumber(e.target.value))}
          />
        </Label1>
      )}

      <Label1>
        <h5>금액</h5>
        <Input
          className="form-control"
          type="number"
          name="amount"
          value={amount}
          onChange={(e) => setAmount(replaceAsNumber(e.target.value))}
        />
      </Label1>
      <Label1>
        <h5>결제 종류</h5>
        <Dropdown>
          <select onChange={(e) => payType(e.target.value)}>
            <option value="cash">현금</option>
            {/* <option value="kakaopay">카카오페이</option> */}
            <option value="virtual">가매입/가매출</option>
          </select>
        </Dropdown>
      </Label1>
    </CommonWrapper>
  );
};

export default TicketTimeEditV2;
